
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import { Action, State } from "vuex-class";
import { AxiosResponse } from "axios";
import {
  AdminJobFairJobApplicantStatusEnum,
  AdminJobFairTransactionCategoryEnum,
  EnumHelper,
  JobInterviewTypeEnum,
  JobTypeEnum,
  LanguageLevelEnum,
} from "@/constants/enum.constant";
import { setCompanyToken } from "@/functions/token.function";
import { downloadBlob, onScroll } from "@/functions/global.function";
import _ from "lodash";
import toast from "@/functions/toast.function";
import moment from "moment";
import ModalJobDetail from "@/views/ModalJobDetail.vue";
import { WHATSAPP_NUMBER } from "@/constants/misc.constant";
import Loading from "@/components/Loading.vue";
import { CompanyState } from "@/store/company/types";

@Component({
  components: {
    Loading,
    ModalJobDetail,
    AppLayout,
  },
  filters,
})
export default class CompanyDashboard extends Vue {
  @Action("getCountry", { namespace: "admin" })
  getCountry: any;
  @Action("getProvince", { namespace: "admin" })
  getProvince: any;
  @Action("getCity", { namespace: "admin" })
  getCity: any;
  @Action("getSchoolType", { namespace: "admin" })
  getSchoolType: any;
  @Action("getSoftSkill", { namespace: "admin" })
  getSoftSkill: any;
  @Action("getLanguage", { namespace: "admin" })
  getLanguage: any;
  @Action("getAdminJobFairCompanySelf", { namespace: "admin" })
  getAdminJobFairCompanySelf: any;
  @Action("getAdminJobFairCompanyDetail", { namespace: "admin" })
  getAdminJobFairCompanyDetail: any;
  @Action("adminJobFairCompanyDownload", { namespace: "admin" })
  adminJobFairCompanyDownload: any;
  @Action("adminJobFairCompanyDownloadJobs", { namespace: "admin" })
  adminJobFairCompanyDownloadJobs: any;
  @Action("adminJobFairCompanyDownloadJob", { namespace: "admin" })
  adminJobFairCompanyDownloadJob: any;
  @Action("getAdminJobFairCompanyJob", { namespace: "admin" })
  getAdminJobFairCompanyJob: any;
  @Action("adminJobFairAddJob", { namespace: "admin" })
  adminJobFairAddJob: any;
  @Action("adminJobFairEditJob", { namespace: "admin" })
  adminJobFairEditJob: any;
  @Action("adminJobFairDeleteJob", { namespace: "admin" })
  adminJobFairDeleteJob: any;
  @Action("getAdminJobFairCompanyVisitor", { namespace: "admin" })
  getAdminJobFairCompanyVisitor: any;
  @Action("getAdminJobFairJobApplicant", { namespace: "admin" })
  getAdminJobFairJobApplicant: any;
  @Action("adminJobFairApplicantReview", { namespace: "admin" })
  adminJobFairApplicantReview: any;
  @Action("adminJobFairApplicantInvite", { namespace: "admin" })
  adminJobFairApplicantInvite: any;
  @Action("adminJobFairApplicantReject", { namespace: "admin" })
  adminJobFairApplicantReject: any;
  @Action("adminJobFairApplicantApprove", { namespace: "admin" })
  adminJobFairApplicantApprove: any;
  @Action("getAdminJobFairCompanyCandidateAppliedJobs", { namespace: "admin" })
  getAdminJobFairCompanyCandidateAppliedJobs: any;
  @Action("getAdminJobFairCompanySection", { namespace: "admin" })
  getAdminJobFairCompanySection: any;
  @Action("getMasterJobs", { namespace: "company" })
  getMasterJobs: any;
  @Action("adminJobFairDownloadAllCv", { namespace: "admin" })
  adminJobFairDownloadAllCv!: ServiceCall<Blob, number, Blob>;
  @Action("adminJobFairDownloadCv", { namespace: "admin" })
  adminJobFairDownloadCv!: ServiceCall<Blob, number, Blob>;

  @State("locale")
  locale!: string;
  @State("masterJobs", { namespace: "company" })
  masterJobs!: CompanyState["masterJobs"];

  jobs: Array<any> = [];
  visitors: Array<any> = [];
  applicants: Array<any> = [];
  appliedJobs: Array<any> = [];
  countries: Array<any> = [];
  provinces: Array<any> = [];
  cities: Array<any> = [];
  schoolTypes: Array<any> = [];
  languages: Array<any> = [];
  softSkills: Array<any> = [];
  sections: Array<any> = [];
  filteredSections: Array<any> = [];
  selectedSections: Array<any> = [];
  profile: any = null;
  company: any = null;
  job: any = null;
  visitor: any = null;
  applicant: any = null;
  country: any = null;
  province: any = null;
  city: any = null;
  type: any = null;
  tab = 1;
  filterJobSection: any = null;
  filterJobQuestion = "";
  name = "";
  description = "";
  requirement = "";
  startSalary = "";
  endSalary = "";
  schoolType: any = null;
  major = "";
  language: any = null;
  softSkill: any = null;
  hardSkill = "";
  message = "";
  interviewType: any = null;
  datetime = "";
  location = "";
  isEdit = false;
  appliedJobsStatus: any = null;
  searchJob = "";
  searchVisitor = "";
  searchApplicant = "";
  searchApplication = "";
  pageJob = 1;
  pageVisitor = 1;
  pageApplicant = 1;
  pageApplication = 1;
  isLastPageJob = false;
  isLastPageVisitor = false;
  isLastPageApplicant = false;
  isLastPageApplication = false;
  isLoadingCompany = false;
  isLoadingJob = false;
  isLoadingVisitor = false;
  isLoadingApplicant = false;
  isLoadingApplication = false;
  isLoadingDownload = false;
  isLoadingDownloadJob = false;
  isLoadingSetJob = false;
  isLoadingSetApplicantStatus = false;
  types = EnumHelper(JobTypeEnum).map((value) => ({
    ...value,
    translation: this.$t(value.name.replaceAll(" ", "_").toLowerCase()),
  }));
  categories = EnumHelper(AdminJobFairTransactionCategoryEnum).map((value) => ({
    ...value,
    translation: (
      this.$t(`category_${value.name.toLowerCase()}`) as any
    ).replaceAll(" {organizer}", ""),
  }));
  statuses = EnumHelper(AdminJobFairJobApplicantStatusEnum).map((value) => ({
    ...value,
    translation: this.$t(
      `status_${value.name.toLowerCase().replaceAll(" ", "_")}`
    ),
  }));
  interviewTypes = EnumHelper(JobInterviewTypeEnum);

  get isEn() {
    return this.locale === "en";
  }

  get isJobFairEnded() {
    if (this.company?.job_fair)
      return moment(moment())
        .utc()
        .isSameOrAfter(this.company?.job_fair.end_date);
    else return false;
  }
  get isOneDay() {
    return moment(this.company?.job_fair.start_date).isSame(
      this.company?.job_fair.end_date,
      "day"
    );
  }

  get applicantSections() {
    let sections: any = [];
    this.applicant?.answers.forEach((answer) => {
      if (
        !sections.some((value: any) => value.id === answer.question.section.id)
      )
        sections.push({
          ...answer.question.section,
          answers: [],
        });
    });
    sections.forEach((section, index) => {
      this.applicant?.answers.forEach((answer) => {
        if (answer.question.section.id === section.id)
          sections[index].answers.push(answer);
      });
    });
    return sections;
  }

  @Watch("filterJobSection")
  onFilterSection() {
    if (this.filterJobSection) {
      this.filteredSections = this.sections.filter(
        (value) => value.id === this.filterJobSection?.id
      );
    } else {
      this.filteredSections = this.sections;
    }
  }
  @Watch("filterJobQuestion")
  onFilterQuestion() {
    if (this.filterJobQuestion) {
      this.filteredSections = this.filteredSections.map((section) => ({
        ...section,
        questions: section.questions.filter((value) =>
          value.translation
            .toLowerCase()
            .includes(this.filterJobQuestion.toLowerCase())
        ),
      }));
    } else {
      if (this.filterJobSection) {
        this.filteredSections = this.sections.filter(
          (value) => value.id === this.filterJobSection?.id
        );
      } else {
        this.filteredSections = this.sections;
      }
    }
  }
  @Watch("country")
  onCountry() {
    this.provinces = [];
    this.cities = [];
    this.province = null;
    this.city = null;

    if (this.country?.id) {
      this.getProvince({
        params: {
          country: this.country?.id,
        },
        success: (response: AxiosResponse) => {
          this.provinces = response.data.data;
        },
      });
    }
  }
  @Watch("province")
  onProvince() {
    this.cities = [];
    this.city = null;

    if (this.province?.id) {
      this.getCity({
        params: {
          province: this.province?.id,
        },
        success: (response: AxiosResponse) => {
          this.cities = response.data.data;
          this.city = this.cities.find(({ id }) => id === this.job.city_id);
          if (this.job && this.province?.id === this.job?.city.province.id)
            this.city = this.job.city;
        },
      });
    }
  }
  @Watch("interviewType")
  onInterviewType() {
    if (this.interviewType?.id === JobInterviewTypeEnum.ONSITE) {
      let now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      this.datetime = now.toISOString().slice(0, 16);
      this.location = this.company?.job_fair.location;
    }
  }

  created() {
    if (this.$route.query && this.$route.query.token) {
      setCompanyToken(this.$route.query.token.toString());
      this.$router.push({
        name: "company-dashboard",
        params: this.$route.params,
      });
    }

    this.getData();
    this.getProfile();
    this.getJobData();
    this.getMasterJobs();
    this.getCountry({
      success: (response: AxiosResponse) => {
        this.countries = response.data.data;
        this.country = this.countries.find(
          (value) => value.name === "Indonesia"
        );
      },
    });

    this.getSchoolType({
      success: (response: AxiosResponse) => {
        this.schoolTypes = response.data.data;
      },
    });

    this.getLanguage({
      success: (response: AxiosResponse) => {
        this.languages = response.data.data;
      },
    });

    this.getSoftSkill({
      success: (response: AxiosResponse) => {
        this.softSkills = response.data.data;
      },
    });

    this.getAdminJobFairCompanySection({
      success: (response: AxiosResponse) => {
        this.sections = response.data.data;
        this.filteredSections = this.sections;
      },
    });
  }

  isPending(status) {
    return status === AdminJobFairJobApplicantStatusEnum.PENDING;
  }
  isInReview(status) {
    return status === AdminJobFairJobApplicantStatusEnum.IN_REVIEW;
  }
  isInvited(status) {
    return status === AdminJobFairJobApplicantStatusEnum.INVITED;
  }
  isRejected(status) {
    return status === AdminJobFairJobApplicantStatusEnum.REJECTED;
  }
  isApproved(status) {
    return status === AdminJobFairJobApplicantStatusEnum.APPROVED;
  }

  check(event, id) {
    if (this.selectedSections.includes(id))
      this.selectedSections = this.selectedSections.filter(
        (value) => value !== id
      );
    else {
      if (this.selectedSections.length < 5) this.selectedSections.push(id);
      else {
        toast.warning("Melebihi limit.");
        event.preventDefault();
      }
    }
  }

  getData() {
    this.isLoadingCompany = true;
    this.getAdminJobFairCompanyDetail({
      success: (response: AxiosResponse) => {
        this.company = response.data.data;
      },
      finally: () => {
        this.isLoadingCompany = false;
      },
    });
  }

  getProfile() {
    this.getAdminJobFairCompanySelf({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        this.profile = response.data.data;
      },
    });
  }

  debounce(callback: any) {
    _.debounce(callback, 500)();
  }

  websocketCompany() {
    (window as any).socket.send(
      JSON.stringify({
        slug: this.$route.params.slug,
        chart: "company",
      })
    );
  }

  websocketIndustryJob() {
    (window as any).socket.send(
      JSON.stringify({
        slug: this.$route.params.slug,
        chart: "industry-job",
      })
    );
  }

  websocketJob() {
    (window as any).socket.send(
      JSON.stringify({
        slug: this.$route.params.slug,
        chart: "job",
      })
    );
  }

  websocketApplicationStatus() {
    (window as any).socket.send(
      JSON.stringify({
        slug: this.$route.params.slug,
        chart: "application-status",
      })
    );
  }

  switchTab(tab: number) {
    this.tab = tab;
    switch (this.tab) {
      case 1:
        this.jobReload();
        break;
      case 2:
        this.visitorReload();
        break;
    }
  }

  onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode !== 43) {
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    }
  }

  requestFullData() {
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER.replace(
        "+",
        ""
      )}?text=*Permintaan+Data+Pengunjung+Job+Fair*%0D%0A%0D%0A*Informasi+Perusahaan*%0D%0A%0D%0ANama+Perusahaan+%3A+${
        this.company?.name
      }%0D%0ANama+PIC+Perusahaan+%3A+${
        this.profile?.name
      }%0D%0APosisi+PIC+Perusahaan+%3A+${
        this.profile?.position
      }%0D%0AEmail+PIC+Perusahaan+%3A+${
        this.profile?.email
      }%0D%0A%0D%0A*Informasi+Acara+Job+Fair*%0D%0A%0D%0ANama+Job+Fair+%3A+${
        this.company?.job_fair.name
      }%0D%0ANama Penyelenggara+%3A+${
        this.company?.job_fair.organizer_name
      }%0D%0ATanggal+Job+Fair+%3A+${filters.date(
        this.company?.job_fair.start_date,
        "DD MMMM YYYY"
      )}+-+${filters.date(this.company?.job_fair.end_date, "DD MMMM YYYY")}`
    );
  }

  reset() {
    this.province = null;
    this.city = null;
    this.type = null;
    this.name = "";
    this.description = "";
    this.startSalary = "";
    this.endSalary = "";
    this.schoolType = null;
    this.major = "";
    this.language = null;
    this.softSkill = null;
    this.hardSkill = "";
    this.selectedSections = [];
  }

  resetInviteInterview() {
    this.message = "";
    this.interviewType = null;
    this.datetime = "";
    this.location = "";
  }

  downloadQr() {
    this.isLoadingDownload = true;
    this.adminJobFairCompanyDownload({
      success: (response: AxiosResponse) => {
        downloadBlob(
          response.data,
          `${this.company.name}_${this.company.job_fair.name}_${this.company.job_fair.organizer_name}.pdf`
        );
      },
      finally: () => {
        this.isLoadingDownload = false;
      },
    });
  }

  downloadJobs() {
    this.isLoadingDownload = true;
    this.adminJobFairCompanyDownloadJobs({
      success: (response: AxiosResponse) => {
        downloadBlob(
          response.data,
          `Poster_${this.company.job_fair.name}_${this.company.job_fair.organizer_name}.pdf`
        );
      },
      finally: () => {
        this.isLoadingDownload = false;
      },
    });
  }

  downloadJob() {
    this.isLoadingDownloadJob = true;
    this.adminJobFairCompanyDownloadJob({
      params: {
        id: this.job?.id,
      },
      success: (response: AxiosResponse) => {
        downloadBlob(
          response.data,
          `Poster_${this.job.name}_${this.company.job_fair.name}_${this.company.job_fair.organizer_name}.pdf`
        );
      },
      finally: () => {
        this.isLoadingDownloadJob = false;
      },
    });
  }

  getJobData(isReload: boolean = false) {
    if (isReload) {
      this.jobs = [];
      this.pageJob = 1;
      this.isLastPageJob = false;
    }
    if (!this.isLoadingJob && !this.isLastPageJob) {
      this.isLoadingJob = true;
      this.getAdminJobFairCompanyJob({
        params: {
          page: this.pageJob,
          name: this.searchJob,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.pageJob;
          this.jobs = [...this.jobs, ...response.data.data.data];
          this.pageJob = isLastPage ? this.pageJob : this.pageJob + 1;
          this.isLastPageJob = isLastPage;
          setTimeout(() => {
            onScroll(".company-jobs", this.getJobData);
          }, 500);
        },
        finally: () => {
          this.isLoadingJob = false;
        },
      });
    }
  }

  getVisitorData(isReload: boolean = false) {
    if (isReload) {
      this.visitors = [];
      this.pageVisitor = 1;
      this.isLastPageVisitor = false;
    }
    if (!this.isLoadingVisitor && !this.isLastPageVisitor) {
      this.isLoadingVisitor = true;
      this.getAdminJobFairCompanyVisitor({
        params: {
          page: this.pageVisitor,
          name: this.searchVisitor,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.pageVisitor;
          this.visitors = [...this.visitors, ...response.data.data.data];
          this.pageVisitor = isLastPage
            ? this.pageVisitor
            : this.pageVisitor + 1;
          this.isLastPageVisitor = isLastPage;
          setTimeout(() => {
            onScroll(".company-visitors", this.getVisitorData);
          }, 500);
        },
        finally: () => {
          this.isLoadingVisitor = false;
        },
      });
    }
  }

  getApplicantData(isReload: boolean = false) {
    if (isReload) {
      this.applicants = [];
      this.pageApplicant = 1;
      this.isLastPageApplicant = false;
    }
    if (!this.isLoadingApplicant && !this.isLastPageApplicant) {
      this.isLoadingApplicant = true;
      this.getAdminJobFairJobApplicant({
        params: {
          id: this.job?.id,
          name: this.searchApplicant,
          page: this.pageApplicant,
        },
        success: (response: AxiosResponse) => {
          const isLastPage =
            response.data.data.last_page === this.pageApplicant;
          this.applicants = [...this.applicants, ...response.data.data.data];
          this.pageApplicant = isLastPage
            ? this.pageApplicant
            : this.pageApplicant + 1;
          this.isLastPageApplicant = isLastPage;
          setTimeout(() => {
            onScroll(".company-job-applicants", this.getApplicantData);
          }, 500);
        },
        finally: () => {
          this.isLoadingApplicant = false;
        },
      });
    }
  }

  getAppliedJobData(isReload: boolean = false) {
    if (isReload) {
      this.appliedJobs = [];
      this.pageApplication = 1;
      this.isLastPageApplication = false;
    }
    if (!this.isLoadingApplication && !this.isLastPageApplication) {
      this.isLoadingApplication = true;
      this.getAdminJobFairCompanyCandidateAppliedJobs({
        params: {
          id: this.visitor?.id,
          company: this.company?.id,
          name: this.searchApplication,
          page: this.pageApplication,
          status: this.appliedJobsStatus?.id,
        },
        success: (response: AxiosResponse) => {
          const isLastPage =
            response.data.data.last_page === this.pageApplication;
          this.appliedJobs = [...this.appliedJobs, ...response.data.data.data];
          this.pageApplication = isLastPage
            ? this.pageApplication
            : this.pageApplication + 1;
          this.isLastPageApplication = isLastPage;
          setTimeout(() => {
            onScroll(".company-job-applied-jobs", this.getAppliedJobData);
          }, 500);
        },
        finally: () => {
          this.isLoadingApplication = false;
        },
      });
    }
  }

  jobReload() {
    this.$bvModal.hide("modal-job-set");
    this.$bvModal.hide("modal-job-delete");
    this.$bvModal.hide("modal-job-detail");
    this.searchJob = "";
    this.job = null;
    this.getData();
    this.getJobData(true);
  }
  visitorReload() {
    this.searchVisitor = "";
    this.visitor = null;
    this.getData();
    this.getVisitorData(true);
  }

  detail(job: any) {
    this.job = job;
    this.getApplicantData(true);
  }

  detailVisitor(visitor: any) {
    this.visitor = visitor;
    this.getAppliedJobData(true);
  }

  detailApplicant(applicant: any) {
    this.applicant = applicant;
    if (applicant?.job) this.job = applicant?.job;
    this.review();
    this.$bvModal.show("modal-applicant");
  }

  edit(isCopy = false) {
    if (!isCopy) this.isEdit = true;
    this.province = this.job.city.province;
    this.type = this.types.find((value) => value.id === this.job.type);
    this.name = this.job.name;
    this.description = this.job.description;
    this.startSalary = this.job.start_salary;
    this.endSalary = this.job.end_salary;
    this.schoolType = this.job.school_type;
    this.major = this.job.majors;
    this.language = this.job.languages.map((value: any) => value.language);
    this.softSkill = this.job.soft_skills.map((value: any) => value.soft_skill);
    this.hardSkill = this.job.hard_skills;
    this.$bvModal.show("modal-job-set");
  }

  addJob() {
    if (this.isJobFairEnded) {
      toast.warning(
        this.isEn ? "Job fair has ended" : "Bursa kerja telah berakhir"
      );
      return false;
    }
    this.isEdit = false;
    this.reset();
    this.$bvModal.show("modal-job-set");
  }

  remove() {
    this.adminJobFairDeleteJob({
      params: {
        id: this.job?.id,
      },
      success: () => {
        this.jobReload();
        this.websocketCompany();
        this.websocketIndustryJob();
        this.websocketJob();
      },
    });
  }

  validateJob(field) {
    switch (field) {
      case "type":
        if (!this.type?.id) {
          toast.warning(
            this.isEn
              ? "Please select job type."
              : "Silahkan pilih tipe lowongan."
          );
          return false;
        }
        return true;
      case "name":
        if (!this.name) {
          toast.warning(
            this.isEn
              ? "Please enter job title."
              : "Silahkan masukkan judul lowongan."
          );
          return false;
        }
        return true;
      case "description":
        if (!this.description) {
          toast.warning(
            this.isEn
              ? "Please enter job description."
              : "Silahkan masukkan deskripsi lowongan."
          );
          return false;
        }
        return true;
      case "province":
        if (!this.province?.id) {
          toast.warning(
            this.isEn ? "Please select province." : "Silahkan pilih provinsi."
          );
          return false;
        }
        return true;
      case "city":
        if (!this.city?.id) {
          toast.warning(
            this.isEn ? "Please select city." : "Silahkan pilih kota."
          );
          return false;
        }
        return true;
      case "startSalary":
        if (this.endSalary && !this.startSalary) {
          toast.warning(
            this.isEn
              ? "Please enter minimum salary."
              : "Silahkan masukkan minimum gaji."
          );
          return false;
        }
        return true;
      case "endSalary":
        if (this.startSalary && !this.endSalary) {
          toast.warning(
            this.isEn
              ? "Please enter maximum salary."
              : "Silahkan masukkan maksimum gaji."
          );
          return false;
        }
        if (parseInt(this.startSalary) > parseInt(this.endSalary)) {
          toast.warning(
            this.isEn
              ? "The maximum salary cannot be less than the minimum salary."
              : "Gaji maksimum tidak boleh lebih kecil dari gaji minimum."
          );
          return false;
        }
        return true;
      case "schoolType":
        if (!this.schoolType) {
          toast.warning(
            this.isEn
              ? "Please select minimum education."
              : "Silahkan pilih minimum pendidikan."
          );
          return false;
        }
        return true;
      case "major":
        if (!this.major) {
          toast.warning(
            this.isEn ? "Please enter major." : "Silahkan masukkan jurusan."
          );
          return false;
        }
        return true;
      case "language":
        if (!this.language || this.language.length < 1) {
          toast.warning(
            this.isEn
              ? "Please select at least one language."
              : "Silahkan pilih paling tidak satu bahasa."
          );
          return false;
        }
        return true;
      case "softSkill":
        if (!this.softSkill || this.softSkill.length < 1) {
          toast.warning(
            this.isEn
              ? "Please select at least one soft skill."
              : "Silahkan pilih paling tidak satu soft skill."
          );
          return false;
        }
        return true;
      case "hardSkill":
        if (!this.hardSkill) {
          toast.warning(
            this.isEn
              ? "Please enter hard skill."
              : "Silahkan masukkan hard skill."
          );
          return false;
        }
        return true;
    }
  }

  submitJob() {
    if (!this.validateJob("type")) return false;
    if (!this.validateJob("name")) return false;
    if (!this.validateJob("description")) return false;
    if (!this.validateJob("province")) return false;
    if (!this.validateJob("city")) return false;
    if (!this.validateJob("startSalary")) return false;
    if (!this.validateJob("endSalary")) return false;
    if (!this.validateJob("schoolType")) return false;
    if (!this.validateJob("major")) return false;
    if (!this.validateJob("language")) return false;
    if (!this.validateJob("softSkill")) return false;
    if (!this.validateJob("hardSkill")) return false;
    this.isLoadingSetJob = true;
    let params = {
      id: this.job?.id,
      city_id: this.city?.id,
      school_type_id: this.schoolType?.id,
      admin_job_fair_id: this.company?.job_fair.id,
      name: this.name,
      type: this.type?.id,
      start_salary: this.startSalary,
      end_salary: this.endSalary,
      description: this.description,
      requirement: this.requirement,
      majors: this.major,
      soft_skills: this.softSkill?.map((value: any) => ({
        soft_skill_id: value.id,
      })),
      hard_skills: this.hardSkill,
      languages: this.language?.map((value: any) => ({
        language_id: value.id,
        level: LanguageLevelEnum.BASIC,
      })),
      sections: this.sections
        .filter(
          (section) =>
            section.questions.filter((question) =>
              this.selectedSections.includes(question.id)
            ).length > 0
        )
        .map((section) => ({
          ...section,
          questions: section.questions.filter((question) =>
            this.selectedSections.includes(question.id)
          ),
        })),
    };
    if (this.isEdit) {
      this.adminJobFairEditJob({
        params: params,
        success: () => {
          this.jobReload();
          this.websocketCompany();
          this.websocketIndustryJob();
          this.websocketJob();
        },
        finally: () => {
          this.isLoadingSetJob = false;
        },
      });
    } else {
      this.adminJobFairAddJob({
        params: params,
        success: () => {
          this.jobReload();
          this.websocketCompany();
          this.websocketIndustryJob();
          this.websocketJob();
        },
        finally: () => {
          this.isLoadingSetJob = false;
        },
      });
    }
  }

  review() {
    if (
      this.applicant?.latest_history.status ===
      AdminJobFairJobApplicantStatusEnum.PENDING
    )
      this.adminJobFairApplicantReview({
        params: {
          id: this.applicant?.id,
        },
        success: () => {
          if (this.tab === 1) this.getApplicantData(true);
          else this.getAppliedJobData(true);
          this.websocketApplicationStatus();
        },
      });
  }

  validateInvite(field) {
    switch (field) {
      case "message":
        if (!this.message) {
          toast.warning(
            this.isEn
              ? "Please enter message invitation."
              : "Silahkan masukkan pesan undangan."
          );
          return false;
        }
        return true;
      case "interviewType":
        if (!this.interviewType?.id) {
          toast.warning(
            this.isEn
              ? "Please select interview type."
              : "Silahkan pilih tipe wawancara."
          );
          return false;
        }
        return true;
      case "datetime":
        if (!this.datetime) {
          toast.warning(
            this.isEn
              ? "Please enter date and time interview."
              : "Silahkan masukkan tanggal dan waktu wawancara."
          );
          return false;
        }
        if (moment().isAfter(this.datetime, "day")) {
          toast.warning(
            this.isEn
              ? "The interview date cannot be before today."
              : "Tanggal wawancara tidak boleh sebelum hari ini."
          );
          return false;
        }
        if (moment().isAfter(this.datetime, "minute")) {
          toast.warning(
            this.isEn
              ? "The interview time cannot be before the current time."
              : "Waktu wawancara tidak boleh sebelum waktu sekarang."
          );
          return false;
        }
        return true;
      case "location":
        if (!this.location) {
          toast.warning(
            this.isEn
              ? "Please enter interview location."
              : "Silahkan masukkan lokasi wawancara."
          );
          return false;
        }
        return true;
    }
  }

  invite() {
    if (!this.validateInvite("message")) return false;
    if (!this.validateInvite("interviewType")) return false;
    if (!this.validateInvite("datetime")) return false;
    if (!this.validateInvite("location")) return false;
    this.isLoadingSetApplicantStatus = true;
    this.adminJobFairApplicantInvite({
      params: {
        id: this.applicant?.id,
        message: this.message,
        type: this.interviewType?.id,
        datetime: this.datetime,
        location: this.location,
      },
      success: () => {
        this.resetInviteInterview();
        this.$bvModal.hide("modal-job-invite");
        this.$bvModal.hide("modal-applicant");
        this.getApplicantData(true);
        this.websocketApplicationStatus();
      },
      finally: () => {
        this.isLoadingSetApplicantStatus = false;
      },
    });
  }

  reject() {
    if (!this.message) {
      toast.warning(
        this.isEn
          ? "Please enter rejection message."
          : "Silahkan masukkan pesan penolakan."
      );
      return false;
    }
    this.isLoadingSetApplicantStatus = true;
    this.adminJobFairApplicantReject({
      params: {
        id: this.applicant?.id,
        message: this.message,
      },
      success: () => {
        this.message = "";
        this.$bvModal.hide("modal-job-reject");
        this.$bvModal.hide("modal-applicant");
        this.getApplicantData(true);
        this.websocketApplicationStatus();
      },
      finally: () => {
        this.isLoadingSetApplicantStatus = false;
      },
    });
  }

  approve() {
    if (!this.message) {
      toast.warning(
        this.isEn
          ? "Please enter acceptance message."
          : "Silahkan masukkan pesan penerimaan."
      );
      return false;
    }
    this.isLoadingSetApplicantStatus = true;
    this.adminJobFairApplicantApprove({
      params: {
        id: this.applicant?.id,
        message: this.message,
      },
      success: () => {
        this.message = "";
        this.$bvModal.hide("modal-job-approve");
        this.$bvModal.hide("modal-applicant");
        this.getApplicantData(true);
        this.websocketApplicationStatus();
      },
      finally: () => {
        this.isLoadingSetApplicantStatus = false;
      },
    });
  }

  onSelectMasterJob(
    item: NonNullable<CompanyState["masterJobs"]>[number] & Record<string, any>
  ) {
    this.job = item;
    this.province = this.provinces.find(({ id }) => {
      return id === item.city.province_id;
    });
    this.city = item.city;
    this.schoolType = item?.school_type;
    this.name = item.name;
    this.type = this.types.find(({ id }) => id === item.type);
    this.startSalary = item.start_salary.toString();
    this.endSalary = item.end_salary.toString();
    this.description = item.description;
    this.requirement = item?.requirement;
    this.major = item?.major;
    this.softSkill = this.softSkills.filter(({ id }) => {
      return !!item.soft_skills.find((v) => v.soft_skill_id === id);
    });
    this.hardSkill = item.hard_skills.map(({ name }) => name).join(", ");
    this.language = this.languages.filter(({ id }) => {
      return !!item.languages.find((v) => v.language_id === id);
    });
    this.sections = item?.sections;
  }

  downloadAllCv() {
    // this.adminJobFairDownloadAllCv({
    //   config: { responseType: "blob" },
    //   params: this.job.id,
    //   success: ({ data, headers }) => {
    //     if ("content-disposition" in headers) {
    //       const anchor = document.createElement("a");
    //       anchor.download =
    //         headers["content-disposition"].match(/filename="([^"]+)"/)[1];
    //       anchor.href = URL.createObjectURL(data);
    //       anchor.click();
    //     }
    //   },
    //   fail: (e) => console.log(e),
    // });

    this.applicants.forEach(async (item) => {
      if (item?.latest_history?.attachment) {
        const file = await fetch(item.latest_history.attachment).then((data) => data.blob())
        const name = String(item.latest_history.attachment).split("/").reverse()[0]
        const anchor = document.createElement("a");
        anchor.download = name
        // anchor.download = `attachment; filename="${name}"`
        // anchor.download = ""

        anchor.href = URL.createObjectURL(file)
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      }
    })
  }
  async downloadCv(item: CompanyDashboard["applicants"][number]) {
    // this.adminJobFairDownloadCv({
    //   config: { responseType: "blob" },
    //   params: item.id,
    //   success: ({ data, headers }) => {
    //     if ("content-disposition" in headers) {
    //       const anchor = document.createElement("a");
    //       anchor.download =
    //         headers["content-disposition"].match(/filename="([^"]+)"/)[1];
    //       anchor.href = URL.createObjectURL(data);
    //       anchor.click();
    //     }
    //   },
    //   fail: (e) => console.log(e),
    // });
    if (item?.latest_history?.attachment) {
      const file = await fetch(item.latest_history.attachment).then((data) => data.blob())
      const name = String(item.latest_history.attachment).split("/").reverse()[0]
      const anchor = document.createElement("a");
      anchor.download = name
      // anchor.download = `attachment; filename="${name}"`
      // anchor.download = ""

      anchor.href = URL.createObjectURL(file)
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    }
  }
}
